import { countryNames } from '$constants/countries';
import { CandidateData } from '../../../../types/candidates';

const filterByCountry = (
  singleCandidate: CandidateData,
  searchedCountry: string[]
) => {
  const hasSomeCountryMatch = searchedCountry.some((singleCountry) =>
    singleCandidate?.ResidenceCountry?.toLowerCase()?.includes(
      singleCountry.toLowerCase()
    )
  );

  const hasUnknownMatch =
    searchedCountry.some(
      (singleCountry) => singleCountry.toLowerCase() === 'unknown'
    ) &&
    !countryNames.some((singleCountry) =>
      singleCandidate?.ResidenceCountry?.toLowerCase()?.includes(
        singleCountry.toLowerCase()
      )
    );

  return (hasSomeCountryMatch || hasUnknownMatch) ?? false;
};

export default filterByCountry;
